import React from 'react';
import PropType from 'prop-types';
import map from 'lodash/map';
import Catalyst from '@Services/Catalyst';
import { dispatchOpenSuggestModal } from '@Containers/Search/SearchBuilder/SuggestModal/SuggestModalActions';
import { dispatchOpenTaxonomyLookupModal } from '@Containers/Search/SearchBuilder/TaxonomyLookupModal/TaxonomyLookupModalActions';
import { ButtonWithIcon } from '@els/els-react--button';

export default function ShowMoreOptions({ suggestionData, updateSuggestedValue, source }) {
  const { data, suggestConfig } = suggestionData;

  const openSuggestionModal = () => {
    const cache = {};
    const isTaxonomyModal = suggestConfig.queryLet && suggestConfig.queryLet.taxonomy;

    const closeCallback = (result = {}) => {
      const { selected, selectedCustom = [] } = result;
      const labelProperty = isTaxonomyModal ? 'name' : 'title';
      const selectedValues = map(selected, labelProperty);
      const values = [].concat(selectedCustom, selectedValues);
      updateSuggestedValue(values.join(';'));
    };

    if (!isTaxonomyModal) {
      dispatchOpenSuggestModal({
        closeCallback,
        suggestConfig,
        suggestInit: {
          search: data.value,
          boundOperator: data.operation,
          cache,
        },
      });
      return;
    }

    Catalyst.trackEvent('buttonClick', {
      buttonType: `taxonomy:${suggestConfig.title}`,
    });

    dispatchOpenTaxonomyLookupModal({
      closeCallback,
      suggestConfig,
      suggestInit: {
        search: data.values,
        boundOperator: data.operation,
        cache,
      },
    });
  };

  return (
    <>
      {source && (
        <div>
          {suggestConfig.queryLet && suggestConfig.queryLet.taxonomy ? (
            <ButtonWithIcon
              id="querybuilder-showmore-taxonomy"
              sprite="EmtreeTaxonomyBrowser"
              type="link"
              iconOnly
              className="cursor-pointer"
              a11y={{ name: 'Show Lookup', description: 'Show Lookup' }}
              onClick={openSuggestionModal}>
              Show Lookup
            </ButtonWithIcon>
          ) : (
            <ButtonWithIcon
              id="querybuilder-showmore-options"
              sprite="SecondaryResult"
              type="link"
              iconOnly
              className="cursor-pointer"
              a11y={{ name: 'Show Lookup', description: 'Show Lookup' }}
              onClick={openSuggestionModal}>
              Show Lookup
            </ButtonWithIcon>
          )}
        </div>
      )}

      {!source && (
        <li className="typeahead-menu__more">
          {suggestConfig.queryLet && suggestConfig.queryLet.taxonomy && (
            <ButtonWithIcon
              id="querybuilder-showmore-taxonomy"
              sprite="SecondaryResult"
              type="link"
              iconOnly
              className="cursor-pointer"
              a11y={{ name: 'Show Lookup', description: 'Show Lookup' }}
              onClick={openSuggestionModal}>
              Show lookup
            </ButtonWithIcon>
          )}
          {!suggestConfig.queryLet && !suggestConfig.queryLet.taxonomy && (
            <ButtonWithIcon
              id="querybuilder-showmore-taxonomy"
              sprite="SecondaryResult"
              type="link"
              iconOnly
              className="cursor-pointer"
              a11y={{ name: 'Show Lookup', description: 'Show Lookup' }}
              onClick={openSuggestionModal}>
              Show Lookup{' '}
            </ButtonWithIcon>
          )}
          <span className="rx-btn-text">
            <span
              className="rx-btn-text-container"
              role="button"
              tabIndex="0"
              aria-label={`More suggestions for ${data.value}`}
              onClick={openSuggestionModal}
              onKeyPress={openSuggestionModal}>
              More suggestions for <strong>{data.value}</strong>
            </span>
          </span>
        </li>
      )}
    </>
  );
}

ShowMoreOptions.propTypes = {
  suggestionData: PropType.object,
  updateSuggestedValue: PropType.func,
  source: PropType.bool,
};
